import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root',
})
export class TextSearchService {
  constructor(public http: HttpClient, private env: EnvService) { }

  filterToPage = new Subject();
  filterToHeader = new Subject();
  dataToContent = new Subject();
  changeType = new Subject();
  search(text, options, units, date, assigned): Observable<any> {
    return this.http.post(`${this.env.URL_API_V1}/searchText/getSearch`, {
      text,
      options,
      units,
    });
  }

  rasSearchText(options): Observable<any> {
    return this.http.post(
      `${this.env.URL_API_V1}/searchText/rasSearchText`,
      {
        options,
      }
    );
  }

  getAllDataFunction(): Observable<any> {
    return this.http.post(
      `${this.env.URL_API_V1}/searchText/graphSearchAll`,
      {}
    );
  }
}
